import React, { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import native from '@native';
import LayoutNavbar from '@root/components/LayoutNavbar';
import ImageSuccess from '@root/assets/successResult.png';
import ImageFail from '@root/assets/failureResult.png';
import Button from '@root/components/Button';
import { useSubscriptionListAction } from '@root/hooks/subscription/useList';
import { useUnBindDevicesState } from '@root/state';

import './style.less';

const PayResult = ({ type }: { type: 'SUCCESS' | 'FAIL' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const getSubscriptionList = useSubscriptionListAction();
  const resetUnBindUpdateTime = useUnBindDevicesState(
    (state) => state.resetUpdateTime,
  );

  const pageType = params['*'];
  const fromLivePage = pageType === 'live';
  const isFree = pageType === 'free';
  const isPromotions = pageType === 'promotions';
  const isSuccess = type === 'SUCCESS';

  const onHome = useCallback(async () => {
    if (fromLivePage) {
      try {
        await native.webView.close();
      } catch (error) {
        // 年订阅活动页支付失败，还跳转到活动页
        navigate(isPromotions && !isSuccess ? '/promotions' : '/', {
          replace: true,
        });
      }
    } else {
      // 年订阅活动页支付失败，还跳转到活动页
      navigate(isPromotions && !isSuccess ? '/promotions' : '/', {
        replace: true,
      });
    }
  }, [fromLivePage, isPromotions, isSuccess, navigate]);

  const textSuccess = isFree
    ? t('operation_successful')
    : t('payment_successful');

  const title = isSuccess ? textSuccess : t('payment_failed');

  useEffect(() => {
    // 如果是购买或者付费成功，则更新首页列表数据
    if (isSuccess) {
      getSubscriptionList();
    }
  }, [getSubscriptionList, isSuccess]);

  useEffect(() => {
    if (isSuccess) {
      resetUnBindUpdateTime();
    }
  }, [resetUnBindUpdateTime, isSuccess]);

  const ResultText = useMemo(() => {
    if (isPromotions) {
      if (isSuccess) {
        return (
          <>
            <h2>{t('subscription_success')}</h2>
            <p>{t('subscription_success_tip')}</p>
          </>
        );
      }

      return (
        <>
          <h2>{t('subscription_failed')}</h2>
          <p>{t('please_try_again')}</p>
        </>
      );
    }

    if (isSuccess) {
      return <p>{isFree ? t('gift_card_completed') : t('purchase_success')}</p>;
    }

    return <p>{t('purchase_failed')}</p>;
  }, [isFree, isPromotions, isSuccess, t]);

  return (
    <LayoutNavbar
      navbarProps={{
        title,
        onBack: onHome,
      }}
      isHomeIcon={false}
    >
      <div className="pay-result">
        <div className="image">
          <img src={isSuccess ? ImageSuccess : ImageFail} />
        </div>
        {ResultText}
        {isPromotions ? null : (
          <Button type="text" onClick={onHome}>
            {fromLivePage ? t('ok') : t('go_home')}
          </Button>
        )}
      </div>
    </LayoutNavbar>
  );
};

export default PayResult;
